export default __webpack_public_path__ + "static/media/equipes.20c60a47.svg";